// extracted by mini-css-extract-plugin
module.exports = {"reportBody":"ReportBody_reportBody__3UX1t","title":"ReportBody_title__14FSN"};